export default {"src":"/_next/static/media/gray-scale.2573b089.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};